<template>
	<div class="vsebina ">

  <div class="glava_vsebine adapt v-adapt">

	<div class="cols">
	<div class="col left grid-col-6">
	  <h1>Neskladja IP</h1>
	</div>
	
	
	
	<div class="col right">
	</div>
	
	</div>
  </div>
  
  <div class="telo_vsebine adapt v-adapt">
<div v-if="!pridelovalecid">
  NI PODATKOV
</div>
<div v-else>
<div>
	  <div :style="{ display: 'inline-block' }">
		  Sezona
		  <br />
		  <dropdownlist
			  :data-items="sezonePisanje"
			  :text-field="'sezona'"
			  @change="sezonaChange"
			  :value="dataSezona"
			  disabled
		  />
      <pridelovalec :pridelovalec="pridelovalec" :sezona="dataSezona.sezona" shema="IP" :kontrolaid="kontrolaid"
                    :podshema="kontrola.podrocjecertificiranja"></pridelovalec>
		  
		</div>
	  </div>
<div class="uporabnik-spacer" style="margin-top:2rem"></div>
<div class="">
<form @submit.prevent="handleSubmit" class="k-form">
	<div class="display-row mt-1 display-row-form" >
            <span>Kontrolna številka</span>
             <kinput disabled type="text" v-model="pridelovalec.kontrolnaStevilka"/>
		</div>
		<div class="display-row mt-1 display-row-form" >
            <span>Shema certificiranja</span>
             <kinput disabled type="text" value="Integrirana pridelava"/>
		</div>
		<div class="display-row mt-1 display-row-form" >
            <span>Področje</span>
            <dropdownlist 
                    :data-items="podrocjacertificiranja.map(i=>i.naziv)"
                    v-model="kontrola.podrocjecertificiranja"
					disabled
					
			></dropdownlist>
		</div>
		<div class="display-row mt-1 display-row-form" >
            <span>Ocena tveganja</span>
             <kinput disabled type="text" v-model="pridelovalec.ocenatveganja"/>
		</div>
		<div class="display-row mt-1 display-row-form" >
            <span>Status kontrole</span>
            <dropdownlist 
                    :data-items="statusnadzora.map(i=>i.naziv)"
                    v-model="kontrola.status"
					disabled
					
			></dropdownlist>
		</div>
		<div class="display-row mt-1 display-row-form" >
            <span>Član skupine</span>
			<kinput disabled type="text" v-model="pridelovalec.skupina"/>
		</div>
		
		
	<div class="form-group">
		<div class="km-widget km-buttongroup k-widget k-button-group">
			<button class="k-button k-primary" :disabled="pridelovalec.pisanje==0" @click="shraniKontrole" >Shrani</button>
			<button class="k-button k-primary" @click="nazaj" >Nazaj</button>
		</div>
    </div>

		
	<div class="left-border-for-children" style="width:'100%'">
		
		<div class="form-fieldset-header mt-1">
			<h2>Neskladja</h2>
		</div>
		
		<Grid  
                        :data-items="neskladja"
                        :columns='[
							{ field: "kontrolnatocka", title:"Knt. točka",editable:false,width: "80px"},
                            { field: "skladnost", title:"Skladnost",editable:true,width: "80px",cell:"ddneskladja"},
                            { field: "komentar", title:"Opis neskladnosti",editable:false,width: "150px"},
                            { field: "stopnjaneskladja", title:"Stopnja", editable:false, width: "80px" },
                            { field: "ukrep", title:"Ukrep", editable:false, width: "150px" },
                            { field: "rok", title:"Rok za odpravo", editable:false,width: "150px", type:"date",editor:"date",format:"{0:d}" },
                            { field: "odpravljeno", title:"Odpravljeno", editable:true,width: "100px", cell:"cbItem",editor:"boolean" },
                            { field: "datumodprave", title:"Datum odprave", editable:true, width: "150px", type:"date",editor:"date",format:"{0:d}"},
                            { field: "komentarodprave", title:"Komentar",editable:true,width: "350px"},
                            { cell: "priloge", title:"Priloge", editable:true, width: "250px"},
                           
                        ]'
                    
                        @itemchange="itemChange"
                        :edit-field="'edit'"
                       
		>
		
    <template v-slot:ddneskladja="{props}">
      <td>
    <dropdownlist 
                    :data-items="vrsteneskladnosti"
                    v-model="props.dataItem[props.field]"
					disabled
					
			></dropdownlist>
    </td>
    </template>   
    <template v-slot:cbItem="{props}">
      <td>
                      <input type="checkbox" v-model="props.dataItem[props.field]" class="k-checkbox"/>
                    </td>
                    </template>

        <template v-slot:priloge="{props}">
			<td>
        <label for="priponkaseznam" class="k-form-field">
				<upload
					:files="props.dataItem.priloge"
					:batch="false"
					:multiple="true"
					:with-credentials="false"
					@add="onAdd($event,props)"
					@remove="onRemove($event,props)"
					@progress="onProgress($event,props)"
					@statuschange="onStatusChange($event,props)"
					@beforeupload="authorize"
					@beforeremove="authorize"
					:save-url="saveurl"
					:remove-url="removeurl"
          list="prenesidatoteke"
          >
          <template v-slot:prenesidatoteke="{props}">
            <div style="display:flex">
              <button  class="k-primary k-button"
                         title="Prenesi" @click="downloadurl(props.files)">
                        <font-awesome-icon icon="download"/>
            </button>
            
          <single :files="props.files" @remove="onRemove" :async="props.async"/>
        </div>
        </template>
        </upload>
        
			</label>
		</td>
        </template>
    	<toolbar>
            <div class="km-widget km-buttongroup k-widget k-button-group">
			</div>
				
			</toolbar>
			<GridNoRecords >
						Ni podatkov!
			</GridNoRecords>
		</Grid>

	</div>
		
	
</form>
    </div>
    </div>
    </div>
    </div>

</template>

<style scoped>

	.k-textbox{
		width:100%
	}
	.mt-1 {
	margin-top: 1rem !important;
	}

	.display-row{
		display:flex;
		align-items:center;
		gap:1rem;
		
	}
	.display-row-form>*:first-child{
		flex:0 0 25%;
	}
</style>
<script>

import { mapState, mapActions,mapMutations } from 'vuex'
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
//import '@progress/kendo-ui' // This will import the entire Kendo UI library
import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';
import { DatePicker, DateTimePicker } from '@progress/kendo-vue-dateinputs';
import { Input } from '@progress/kendo-vue-inputs';
import { provideIntlService } from '@progress/kendo-vue-intl';
import { Checkbox } from "@progress/kendo-vue-inputs";
import { filterBy } from '@progress/kendo-data-query';
import { Button, ButtonGroup } from '@progress/kendo-vue-buttons';
import { Grid, GridToolbar, GridNoRecords  } from '@progress/kendo-vue-grid';
import { MultiSelect,DropDownList,ComboBox } from '@progress/kendo-vue-dropdowns';
import StatusDownCell from './support/SifrantStatusovDropDown';
import StatusCommandCell from './support/SifrantStatusovCommandCell';
//import SifrantKontrolaDownCell from './support/SifrantKontrolaDropDown';
import PridelovalecKratko from './support/PridelovalecKratko';
import { authHeader } from '../helpers';
import { Upload,UploadListSingleItem } from '@progress/kendo-vue-upload';
import { process } from '@progress/kendo-data-query';
import moment from 'moment'
import { sifrant } from '../store/sifrant.module';
import { kontrolaService } from '../services/kontrola.service';
import CheckBoxGridItem from './support/CheckBoxGridItem';




export default {
  components:{
    'single':UploadListSingleItem,
	'kinput': Input,
	'kbutton': Button,
  'cbItem': CheckBoxGridItem,
	'kendo-datepicker': DatePicker,
	'kendodatetimepicker': DateTimePicker,
    'multiselect': MultiSelect,
    'kendo-checkbox': Checkbox,
      'ukaznigumbiknt': StatusCommandCell,
      'ddcell': StatusDownCell,
      'combobox': ComboBox,
      'dropdownlist': DropDownList,
  //    'sifkontroleddcell': SifrantKontroleDownCell,
      'Grid': Grid,
      'GridNoRecords': GridNoRecords,
      'toolbar': GridToolbar,
      'pridelovalec':PridelovalecKratko,
	  upload: Upload,
  },
  props:['sezona','pridelovalecid','shema','kontrolaid'],
    data () {
        return {
          vrsteneskladnosti:["DA","NE","NR"],
			ipobsegcertificiranjafilter:{},
			ip:{},
            dataResult:[],
            filter: null,
            sort: null,
            kontrola:{
              priprava:{obseg:{}},
				podrocjecertificiranja:"",
				status:"",
				stkontrole:0,
				datumnadzora:new Date(),
				vrstakontrole:"",
				lokacijakontrole:"",
				zacetekkontrole:new Date(),
				koneckontrole:new Date(),
				trajanje:0,
				vzorcenje:true,
				vzorci:[],
        loader:true,
				prisotneosebe:[],
				seznam:[],
				storitvepodizvajalca:[],
				podizvajalci:[{naziv:"",naslov:"",dejavnost:"",datumzadnjeaktivnosti:new Date(),edit:true}],
				storitvepodizvajalca:[{naziv:"",dejavnost:"",datumzadnjeaktivnosti:new Date(),edit:true}],
				neskladnosti:"",
				posebnosti:"",
				ponovna:"",
				zuppripombe:false,
				zuppripomba:"",
				zupposlannaemail:"", //email iz podatkov
				zupprevzetnasedezu:"",
				zupprevzetobkontroli:"",
				zakljuceno:"",
				izvajalcikontrole:[{naziv:"",datum:new Date(),edit:true}]
			},
			files:[],
			kontrolorji:[],
			sifrantTree:{},
            dataLoading:false,
			podrocjacertificiranja:[{naziv:"IPS",id:1},{naziv:"IPG",id:2},{naziv:"IPP",id:3},{naziv:"IPZ",id:4},{naziv:"IPH",id:5}],
           statusnadzora:[
			{id:1,naziv:"nova"},
			{id:2,naziv:"v teku"},
			{id:3,naziv:"odločitev"},
			{id:4,naziv:"konec"},
		   ],
		   statusprisotnihoseb:[
			{id:1,naziv:"izvajalec"},
			{id:2,naziv:"pooblaščenec"},
			{id:3,naziv:"ostali prisotni"},
			
		   ],
            dataSezona:this.sezona,
          
            updatedData: [],
            editID: null,
          
         
            sort: [
                //{ field: 'vrstakulture', dir: 'asc' } 
            ],
            

           

        }
    },
      computed: {
        neskladja: function () {
          //če je kontrolor tudi vse...
      return this?.kontrola?.neskladja?.filter(n=>n.neskladnost);
    },
		saveurl:{
            get(){
				return `${Vue.prototype.$config.apiUrl}/datoteke/dodaj/priloge`
			}
		},
		removeurl:{
            get(){
				return `${Vue.prototype.$config.apiUrl}/datoteke/brisi`
			}
		},
        editDisabled(){
          return (this.pridelovalec.pisanje==0)
        },

        ...mapState({gridData(state) {
          return state.kontrola.kontrola;
        }}),

        ...mapState('pridelava', ['pridelovalec']) ,
        ...mapState('sifrant', ['sifrant']) ,
        ...mapState('users',['sezonePisanje']),

        
        kontrolorjiSifrant(){
          return this.kontrolorji.map(i=>{
                i.naziv=i.priimek+' '+i.ime;
                return i;            
          })
        }
      
           },
    created () {

 if(!this.sezona)
        this.dataSezona={sezona:Math.max(...this.sezonePisanje.map(s=>s.sezona))};
      else
      this.dataSezona={sezona:this.sezona};
		
	  this.naloziPodatke();

      
    },
  


    methods: {
      ...mapActions('pridelava', ['loadIdPoSezoni','loadOne']),
        ...mapActions('kontrola', ['load','save','loadPreteklaSezona']),
        ...mapActions({naloziSifrant: 'sifrant/load'}),
        ...mapMutations('kontrola',['update',"add","remove","makeEditable",'replace']),

        authorize(event) {
			event.headers=authHeader();
		},
    downloadurl(file){
     
let url=`${Vue.prototype.$config.apiUrl}/datoteke/${file[0]?.datotekaid}`;
console.log(url);

fetch(url, {method: 'GET',headers:authHeader()})
        //.then(handleResponse)
        .then(res => {
            let filename="";
          
            const header = res.headers.get('Content-Disposition');
            const parts = header.split(';');
            filename = parts[1].split('=')[1];
            console.log(filename);
            return res.blob().then((blob) => {
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = filename;
                console.log(link.download);
                link.click()
                link.remove(); 
                
                //var file = window.URL.createObjectURL(certifikat);
                //window.location.assign(file);
            });

        }) 



     
      //return  

    },
		onAdd(event,props) {
      console.log("add");
        //props.dataItem.priloge=event.newState;
        Vue.set(props.dataItem,"priloge",event.newState)
      },
      onRemove(event,props) {
        //props.dataItem.priloge=event.newState;
        Vue.set(props.dataItem,"priloge",event.newState)
      },
      onProgress(event,props) {
		console.log("progres");
		console.log(event);
		//props.dataItem.priloge=event.newState;
    Vue.set(props.dataItem,"priloge",event.newState)
      },

      onStatusChange(event,props) {
		
		console.log("done");
		console.log(event);
		//props.dataItem.priloge=event.newState;
    let uid=event.affectedFiles[0]?.uid;
    if(uid){
        let afile=event.newState.find(f=>f.uid==uid);
        afile.datotekaid=event.response?.response?._id;
        
      }
    Vue.set(props.dataItem,"priloge",event.newState)
    //Vue.set(this.kontrola,'seznam',{datotekaid:event.response?.response?._id,files:this.files});
      },



        rowRenderFunction: function (h, trElement , defaultSlots, props ) {
            console.log(trElement);
            console.log(props.dataItem);
            if(props.dataItem.jeaktivna!=1)
            trElement.data.class+=" deleted_element";

                return trElement;
            },
             nogaNazivVsot: function (h, emptyElement , props, listeners ) {
            return h('span', {}, ['Vsota:']);
        },
        //gvž in število
        nogaVsotaStevila: function (h, emptyElement , props, listeners ) {
          if(this.gridData)
            return h('span', {}, [kendo.toString(this.gridData.reduce((acc, current) => acc+=current.jeaktivna?(current.stevilo?current.stevilo:0):0, 0),"n0")]);
        },
        nogaVsotaGvz: function (h, emptyElement , props, listeners ) {
          if(this.gridData)
            return h('span', {}, [kendo.toString(this.gridData.reduce((acc, current) => acc+=current.jeaktivna?(current.vsotagvz?current.vsotagvz:0):0, 0),"n3")]);
        },
        formatDate: function (h, emptyElement , props, listeners ) {
            if(props.dataItem.inEdit)
              return emptyElement
            else
             return h('td', {attrs:{colspan:1}}, [kendo.toString(kendo.parseDate(props.dataItem[props.field]),'d')]);
        },
		izracunajtrajanje(){
			var diff =(this.kontrola.zacetekkontrole.getTime() - this.kontrola.koneckontrole.getTime()) / 1000;
  			diff /= (60 * 60);
  			Vue.set(this.kontrola,"trajanje",Math.abs(Math.ceil(diff)));
			
		},
		dodajvzorcenje(){
            if(!this?.kontrola?.vzorci)
                this.kontrola.vzorci=[];

            const newRecord = { 
				id:0,
				datumvzorcenja:new Date(),
				datumizvida:new Date(),
				idporocila:0,
				datumpregleda:new Date,
				pregledizvedel:"",
				skladno:true,
				opomba:'',
				edit:true};

				this.kontrola.vzorci.push(newRecord);
        }   ,
        removevzorcenje(e){
        
                var index=this.kontrola.vzorci.indexOf(e);
                if(index>=0)
                        this.kontrola.vzorci.splice(index,1)

        },
        vzorcenjechange: function (e) {
            e.dataItem[e.field]=e.value;
		},
		dodajprisotneosebe(){
            if(!this?.kontrola?.prisotneosebe)
                this.kontrola.prisotneosebe=[];

            const newRecord = { 
				ime:"",
				podjetjekmg:"",
				funkcija:"",
				status:"",
				edit:true};

				this.kontrola.prisotneosebe.push(newRecord);
        }   ,
        removeprisotneosebe(e){
        
                var index=this.kontrola.prisotneosebe.indexOf(e);
                if(index>=0)
                        this.kontrola.prisotneosebe.splice(index,1)

        },
        prisotneosebechange: function (e) {
            e.dataItem[e.field]=e.value;
		},
		dodajpodizvajalci(){
            if(!this?.kontrola?.podizvajalci)
                this.kontrola.podizvajalci=[];

            const newRecord = { 
				naziv:"",
				naslov:"",
				dejavnost:"",
				datumzadnjeaktivnosti:new Date(),
				edit:true};

				this.kontrola.podizvajalci.push(newRecord);
        }   ,
        removepodizvajalci(e){
        
                var index=this.kontrola.podizvajalci.indexOf(e);
                if(index>=0)
                        this.kontrola.podizvajalci.splice(index,1)

        },
        podizvajalcichange: function (e) {
            e.dataItem[e.field]=e.value;
		},
		dodajstoritvepodizvajalca(){
            if(!this?.kontrola?.storitvepodizvajalca)
                this.kontrola.storitvepodizvajalca=[];

            const newRecord = { 
				naziv:"",
				dejavnost:"",
				datunzadnjeaktivnosti:new Date(),
				edit:true};

				this.kontrola.storitvepodizvajalca.push(newRecord);
        }   ,
        removestoritvepodizvajalca(e){
        
                var index=this.kontrola.storitvepodizvajalca.indexOf(e);
                if(index>=0)
                        this.kontrola.storitvepodizvajalca.splice(index,1)

        },
        storitvepodizvajalcachange: function (e) {
            e.dataItem[e.field]=e.value;
		},
		
		dodajizvajalcikontrole(){
            if(!this?.kontrola?.izvajalcikontrole)
                this.kontrola.izvajalcikontrole=[];

            const newRecord = { 
				naziv:"",
				dejavnost:"",
				datunzadnjeaktivnosti:new Date(),
				edit:true};

				this.kontrola.izvajalcikontrole.push(newRecord);
        }   ,
        removeizvajalcikontrole(e){
        
                var index=this.kontrola.izvajalcikontrole.indexOf(e);
                if(index>=0)
                        this.kontrola.izvajalcikontrole.splice(index,1)

        },
        izvajalcikontrolechange: function (e) {
            e.dataItem[e.field]=e.value;
		},

	

		saveData(e){
          //this.save( this.dataSezona);
        },
		handleSubmit(e){

		e.preventDefault();
		},

          //error handle za prazen šifrnat!!!!
        naloziPodatke: function(){
          this.dataLoading=true;
		 let sezona=this.dataSezona.sezona;
		 let shema="IP";
		 let pridelovalecid=this.pridelovalecid;
		 let thisComp=this;
		 var sifranti=[
		  this.naloziSifrant({sezona:sezona,sifrant:"kontrolorjiip"}).then(

		  	data=>{
				this.kontrolorji=this.sifrant["kontrolorjiip"];
			},
  			error=>{console.log("tukaj sem!!!");this.dataLoading=false;}
			
			),
			//mogoče filter po vrsti
		this.naloziSifrant({sezona:sezona,sifrant:"ipobsegcertificiranja"}).then(()=>{
            thisComp.ipobsegcertificiranja=thisComp.sifrant["ipobsegcertificiranja"];
			for (let podshema of thisComp.podrocjacertificiranja)
				Vue.set(thisComp.ipobsegcertificiranjafilter,podshema.naziv,thisComp.ipobsegcertificiranja.filter(i=>i.področje==podshema.naziv).slice())
				
        })];
		
		Promise.all(sifranti).then(()=>{
			console.log("Šifranti naloženi")
        

          
		this.loadOne({sezona:sezona,pridelovalecid:pridelovalecid}).then(p=>{

			console.log("Grem po stranko")
			
			let kontaktkmg=p.kontakt.find(k=>k.vloga=="kmetija (kmg)")
                if(!kontaktkmg)
                    kontaktkmg=p.kontakt.find(k=>k.glavni)
                if(!kontaktkmg)
                    kontaktkmg=p.kontakt[0];

			let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==sezona&&s.shema==shema);
		if(!pridelava){
			//javi napako, ne dodaj podatkov
			console.log("resne težave, če ni sheme")
			return;
		}
		//naloži kontrolo, če je id, če ni, napaka...
		this.pridelovalec.kontrolnaStevilka=pridelava.kontrolnaStevilka;
		let novaprijava={
		obseg:{},
		seznam:{datotekaid:null,files:[]},
		datumseznama:(new Date()).toISOString()};

		if(!pridelava.ip)
		{
			Vue.set(pridelava.ip,'prijava',novaprijava)
		}
		if(!pridelava.ip.prijava){
		Vue.set(pridelava.ip,'prijava',novaprijava)
		}
		Vue.set(thisComp,"ip",pridelava.ip)
		thisComp.files=thisComp.ip.prijava?.seznam?.files;
		if(!thisComp.ip.prijava.obseg||Array.isArray(thisComp.ip.prijava.obseg))
		Vue.set(thisComp.ip.prijava,'obseg',{});


		kontrolaService.loadOne(sezona,pridelovalecid,shema,this.kontrolaid).then(
			data=>{

				
				var datumi=["datumkontrole","datumnadzora","zacetekkontrole","koneckontrole","datumnajave"]
				//vzorci datum pregleda
				//datumzadnjeaktivnosti podizvajalci in stortivepodizvajalca
				//izvajalcikontrole datum

				//kontrolor v kontrolorji
				if(!data.kontrolorji)
					data.kontrolorji=[];
				if(!data.kontrolorji.includes(data.kontrolornaziv))
					data.kontrolorji.push(data.kontrolornaziv);

				for (let d of datumi){
					if(data[d])
						data[d]=provideIntlService(thisComp).parseDate( data[d]);
				}
				if(!data.priprava)
					data.priprava={}
				console.log(data);
				data.lokacijakontrole=kontaktkmg.naslov+ ", "+kontaktkmg.postnastevilka + " " +kontaktkmg.posta
				Vue.set(thisComp,'kontrola',data);
        for (let neskladje of data.neskladja)
        {
          neskladje.edit=true;
          neskladje.rok=provideIntlService(thisComp).parseDate(neskladje.rok);
          neskladje.datumodprave=provideIntlService(thisComp).parseDate(neskladje.datumodprave);
          if(neskladje.skladnost=="NE")
            neskladje.neskladnost=true;

        }
       



			},
			err=>{}
		);

		

	  

		});

	});
          
        
      
        },
        sifranKontrolaChange: function(e,dataItem) {

          
               if(!dataItem.oldValues)
              dataItem.oldValues={}


            if(!dataItem.oldValues["vrstakontroleid"])
              dataItem.oldValues["vrstakontroleid"] =dataItem["vrstakontroleid"];

            if(!dataItem.oldValues["vrstakontrole"])
              dataItem.oldValues["vrstakontrole"] =dataItem["vrstakontrole"];



            Vue.set( dataItem, 'vrstakontrole',e.value.naziv);
              Vue.set( dataItem, 'vrstakontroleid',e.value.id);
            
    
        },
        sifrantNacinChange: function(e,dataItem) {

          
               if(!dataItem.oldValues)
              dataItem.oldValues={}


           
            if(!dataItem.oldValues["nacinkontrole"])
              dataItem.oldValues["nacinkontrole"] =dataItem["nacinkontrole"];



      
              Vue.set( dataItem, 'nacinkontrole',e.value.naziv);
            
    
        },
          sifranMnenjeChange: function(e,dataItem) {

          
               if(!dataItem.oldValues)
              dataItem.oldValues={}


            
            if(!dataItem.oldValues["mnenjekontrolorja"])
              dataItem.oldValues["mnenjekontrolorja"] =dataItem["mnenjekontrolorja"];

            Vue.set( dataItem, 'mnenjekontrolorja',e.value.naziv);
            
            
    
        },
        sifranMestoChange: function(e,dataItem) {

          
if(!dataItem.oldValues)
dataItem.oldValues={}



if(!dataItem.oldValues["mestokontrole"])
dataItem.oldValues["mestokontrole"] =dataItem["mestokontrole"];

Vue.set( dataItem, 'mestokontrole',e.value.naziv);



},

        kontrolorChange: function(e,dataItem) {

          
               if(!dataItem.oldValues)
              dataItem.oldValues={}


            if(!dataItem.oldValues["kontrolorid"])
              dataItem.oldValues["kontrolor"] =dataItem["kontrolor"];

         
            Vue.set( dataItem, 'kontrolor',e.value.id);
            this.test=e.value.id
         
    
        },
        itemChange: function (e) {
            if(!e.dataItem.oldValues)
              e.dataItem.oldValues={}
            if(!e.dataItem.oldValues[e.field])
              e.dataItem.oldValues[e.field] =e.dataItem[e.field];
          
          Vue.set( e.dataItem, e.field,e.value);

        //  if(e.field=="stevilo")
          //    Vue.set( e.dataItem, 'vsotagvz',(e.value?e.value:0)*this.sifrant['proizvod'].find(s=>s.id==e.dataItem.proizvodid).gvz);              
           
        },
        dodajIzPrejsnjeSezone(){
            this.loadPreteklaSezona({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid,makeEditable:!this.editDisabled});

        },

        //default vrednosti
         vstavi() {
            const dataItem = { inEdit: true,jeaktivna:1,
                  zaporednastevilka:this.gridData.reduce((a,c)=>{return c.zaporednastevilka>a?c.zaporednastevilka:a},0)+1,
                  datumkontrole:new Date(),
                  vrstakontroleid:this.sifrant["vrstakontrolepridelovalca"][0].id,
                  vrstakontrole:this.sifrant["vrstakontrolepridelovalca"][0].naziv,
                  nacinkontrole:this.sifrant["nacinkontrolepridelovalca"][0].naziv,
                  mestokontrole:this.sifrant["mestokontrolepridelovalca"][0].naziv,
                  //mestokontrole:"",
                  mnenjekontrolorjaid:this.sifrant["mnenjekontrolorja"][0].id,
                  mnenjekontrolorja:this.sifrant["mnenjekontrolorja"][0].naziv
                   };
            this.add(dataItem);
        },
        edit: function (e) {
            e.dataItem.inEdit = true;
            e.dataItem.jeaktivna = 1;
            
            this.update(e.dataItem);
        },
        cancel(e) {
            if (e.dataItem.id>0) {
            var dataItem=e.dataItem;
            for (const value in dataItem.oldValues){
               Vue.set( dataItem, value,dataItem.oldValues[value]);
            }
             Vue.set( dataItem, jeaktivna,0);
             Vue.set( dataItem, jeaktivna,1);
              this.update(dataItem);
            
            } else {
                this.remove(e.dataItem);
            }
        },
        saveItem: function(e) {
           e.dataItem.inEdit = undefined;
             e.dataItem.jeaktivna = 1;
            this.update(e.dataItem);
        },
        removeItem(e) {
            e.dataItem.inEdit =!e.dataItem.inEdit;
            e.dataItem.jeaktivna=e.dataItem.jeaktivna?0:1;
            this.update(e.dataItem);

        },
        //tu je treba dodat še shemo...
       sezonaChange(event) {
            const sezona = event.value;
            this.dataSezona=sezona;
            //this.loadOne({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid}).then(pridelovalec=>{
              //this.pridelovalecid=pridelovalec.id;
              this.$router.push({ name: 'pripravakontroleip', params: {sezona:sezona.sezona,pridelovalecid:this.pridelovalec._id,kontrolaid:this.kontrolaid,podshema:this.kontrola.podrocjecertificiranja}} );
           
             this.pridelovalec.sezona=this.sezona;
             this.naloziPodatke();
             // });



        },
/*
             @datastatechange="dataStateChange"
dataStateChange (event) {
            console.log("DataStateChange");
            console.log(event);
            this.createAppState(event.data);
            this.dataResult = process(this.gerk, {});

        },
  */    
        async shraniKontrole () {
			//kaj narediš s seznamom in obsegom.... vprašaj...

			await kontrolaService.saveOne(this.kontrola,this.sezona,this.pridelovalecid,this.shema,this.kontrolaid)
              //this.save();
    },
       
        
    }
};
</script>

